import { Legend, Tooltip, Chart, LinearScale, PointElement, BarElement, BarController } from 'chart.js'

import WeightedBarController from './extensions/WeightedBarController'
import LinearLabelScale from './extensions/LinearLabelScale'

const init = () => Chart.register(Legend, Tooltip, BarController, PointElement, BarElement, LinearScale, LinearLabelScale, WeightedBarController)

export default init